import React, { Children } from 'react';

const ImageButton = (props) => {
    return (
        <div className={["ImageButton", props.className].join(" ")}>
            <button className="d-flex flex-column align-items-center justify-content-center" disabled={props.disabled}  onClick={props.onClick}>
                {
                    props.image && <img src={props.image} alt={props.label} />
                }
                {props.label}
                {Children.map(props.children, (child, i) => {
                    return (<React.Fragment>{child}</React.Fragment>)
                })}
            </button>
        </div>
    )
}

export default ImageButton;